module.exports = __webpack_public_path__ + "static/classhook-homepage-791d5498b6ee81865039a90bf7afbbe1.jpg";